
export enum Format {
    PIZZA = 1,
    BAR = 2,
    BOARD = 3
}